var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrush(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 10.9999L17.3694 5.67529C17.7732 5.27152 18 4.7239 18 4.1529C18 3.58189 17.7732 3.03427 17.3694 2.6305C16.9656 2.22674 16.418 1.99991 15.847 1.99991C15.276 1.99991 14.7284 2.22674 14.3246 2.6305L9 8.00012",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73234 11.093C2.24727 12.5471 2 17.9999 2 17.9999C2 17.9999 7.44575 17.5157 8.93227 16.1823C9.27038 15.8503 9.53893 15.4543 9.72226 15.0174C9.90558 14.5805 10 14.1114 10 13.6377C10 13.1639 9.90558 12.6948 9.72226 12.2579C9.53893 11.821 9.27038 11.425 8.93227 11.093C8.26913 10.4154 7.36742 10.0235 6.4194 10.0009C5.47138 9.97839 4.55205 10.327 3.85743 10.9723C3.81379 11.0116 3.77307 11.0523 3.73234 11.093Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush);
export default __webpack_public_path__ + "static/media/brush.f827c389e7ad6e151a0e551d8504eb28.svg";
export { ForwardRef as ReactComponent };